import React, { useEffect, useRef, useState } from 'react';
import FJLocalStore from '../../../../../store/FJLocalStore.js';
import classNames from 'classnames';
import styles from './FJLanguageDropdown.module.less';
import ArrowIcon from '../../../../../assets/svg/button-right.svg?react';
import FJSideModel from '../../../../../common/components/FJSideModel/FJSideModel.jsx';
import FJLanguageListMenu from './FJLanguageListMenu.jsx';
import FJEvent from '../../../../../store/FJEvent.js';

const FJLanguageDropdown = props => {
    const { selectedLanguage, languageList, onClick } = props;
    const [showSideModel, setShowSideModel] = useState(false);

    useEffect(() => {
        return FJEvent.subscribe('CLOSE_LANGUAGE_SELECT_PANEL', () => {
            setShowSideModel(false);
        });
    }, []);

    useEffect(() => {
        const __onKeydown = e => {
            if (e.key === 'Escape') {
                setShowSideModel(false);
            }
        };
        if (showSideModel) {
            document.addEventListener('keydown', __onKeydown);
        } else {
            document.removeEventListener('keydown', __onKeydown);
        }
        return () => {
            document.removeEventListener('keydown', __onKeydown);
        };
    }, [showSideModel]);

    const _handleClick = e => {
        e.stopPropagation();
        setShowSideModel(!showSideModel);
    };

    const _handleOnMouseDown = e => {
        showSideModel && e.stopPropagation();
    };

    const _onClick = language => {
        onClick && onClick(language);
        setShowSideModel(false);
    };

    return (
        <>
            <div className={styles.box}>
                <div className={styles.header_title}>{FJLocalStore._('choose-original-language')}</div>
                <div className={styles.menu_button} onClick={_handleClick} onMouseDown={_handleOnMouseDown}>
                    {FJLocalStore._(selectedLanguage)}
                    <ArrowIcon className={styles.arrow_icon} />
                </div>
            </div>
            <FJSideModel
                position={{ top: 130, left: 478 }}
                active={showSideModel}
                className={styles.side_model}
                onClose={() => setShowSideModel(false)}
            >
                <FJLanguageListMenu
                    list={languageList}
                    selectedLanguage={selectedLanguage}
                    onClick={_onClick}
                    isShow={showSideModel}
                />
            </FJSideModel>
        </>
    );
};

export default FJLanguageDropdown;
